import { createSlice } from "@reduxjs/toolkit";

export interface CounterState {
  thisDevice: {
    deviceId: string;
    id: string;
    userId: string;
  };
  isLoading: boolean;
  error: string;
  token: object;
  creds: {
    userName: string;
    password: string;
  };
  secureCheckEnabled: boolean;
}

const initialState: CounterState = {
  thisDevice: { deviceId: "", id: "", userId: "" },
  isLoading: false,
  error: "",
  token: {
    access_token: "",
    token_type: "",
    expires_in: 0,
    scope: "",
    refresh_expires_in: 0,
    refresh_token: "",
    "not-before-policy": 0,
    session_state: "",
  },
  creds: {
    userName: "",
    password: "",
  },
  secureCheckEnabled: false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
      return state;
    },
    setCreds: (state, action) => {
      state.creds = action.payload;
      return state;
    },
    enableSecureCheck: (state) => {
      state.secureCheckEnabled = true;
    },
    disableSecureCheck: (state) => {
      state.secureCheckEnabled = false;
    },
  },
});

export const { setToken, setCreds, enableSecureCheck, disableSecureCheck } =
  authSlice.actions;

export default authSlice.reducer;

export const selectLoadingStatus = (state: any) => {
  return state.auth.isLoading;
};
export const selectError = (state: any) => {
  return state.auth.error;
};

export const selectToken = (state: any) => {
  return state.auth.token;
};

export const selectCreds = (state: any) => {
  return state.auth.creds;
};
